import { Box, Button, Grid, TextField, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import Footer from "../../common/Footer";
import { useNavigate } from "react-router";
// import { getAllCourses } from "./coursesApi";
import { useSelector } from "react-redux";
import useDebounce from "../../common/debounce";
import SearchIcon from "@mui/icons-material/Search";
import CompnayInforamtion from "./modal";
import {
  getAllCompanypRODUCTS,
  getCompanypRODUCTS,
  interestedCompanyEnquiries,
} from "../WhiteLabels/whitelabelApi";
import Swal from "sweetalert2";
import { swalAlertPopProps } from "../../utils/commonUtils";
import { routePath } from "../../constants/routePath";

export default function LabelsList() {
  const navigate = useNavigate();
  const [allCourse, setAllCourse] = useState();
  const searchValue = useSelector((state) => state.reducer.searchValue);
  const [searchhere, setSearchHere] = useState("");
  const debouncedSearchHere = useDebounce(searchhere, 500);
  const debouncedSearchValue = useDebounce(searchValue, 500);
  const [modalData, setModalData] = useState();
  const [viewType, setViewType] = useState("");
  const [open, setOpen] = useState(false);
  const userDetail = useSelector((state) => state.reducer.userDetail);
  let val = userDetail?.profileId?.split("?")[1];
  let billerId = Number(val?.split("=")[1]?.replace(/\D/g, ""));

  const getCourses = async () => {
    const payload = { billerId: 0 };

    // console.log("bbbb", billerId);

    getAllCompanypRODUCTS(payload, (data) => {
      // console.log("Courses- ", data.data.data.list);
      setAllCourse(data.data.data.list);
    });
  };
  useEffect(() => {
    getCourses();
  }, [debouncedSearchValue, debouncedSearchHere]);

  const formatDate = (date) =>
    new Date(date)
      .toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      })
      .replace(/ /g, "-");

  const token = sessionStorage.getItem("smbToken");

  const Applyinterested = async (id) => {
    // console.log("bbbb", billerId);
    if (!token) {
      Swal.fire({
        text: "Please login",
        icon: "error",
        ...swalAlertPopProps,
      }).then((result) => {
        navigate(routePath.CUSTOMERLOGIN); 
      });

      return; 
    }

    interestedCompanyEnquiries({ companyProductId: id }, (data) => {
      getCourses();
    });
  };
  return (
    <>
      <Box
        sx={{
          fontFamily: "'Montserrat', sans-serif",
          minHeight: "100vh",
          p: { xs: 2, sm: 3, md: 5 },
          px: { xs: 2, sm: 2, md: 2, lg: 8 },
        }}
      >
        {/* Header */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: { xs: 2, sm: 3, md: 4 },
          }}
        >
          <Typography
            sx={{
              fontSize: { xs: 18, sm: 22, md: 28 },
              fontWeight: 500,
              display: { sm: "block", xs: "none" },
            }}
          >
            White Labels
          </Typography>

          <TextField
            placeholder={`Search ...`}
            fullWidth
            InputProps={{
              endAdornment: (
                <SearchIcon
                  sx={{ cursor: "pointer" }}
                  // onClick={handleSearchClick}
                />
              ),
            }}
            sx={{
              backgroundColor: "#fff",
              "& .MuiInputBase-input": {
                padding: "7.5px 10px !important",
                fontFamily: "Kanit",
              },
              display: { sm: "none", xs: "block" },

              "& .MuiInputBase-input::placeholder": {
                color: "#585858",
                opacity: 1,
              },
            }}
            // onClick={handleSearchClick}
            value={searchhere}
            // onChange={(e) =>
            //   dispatch(setSearchValue(e.target.value))
            // }

            onChange={(e) => setSearchHere(e.target.value)}
            // onClick={(e) => handleSearchClickOrType(e)}
          />
        </Box>

        <Grid container spacing={{ xs: 2, sm: 1, md: 2, lg: 2 }}>
          {allCourse?.map((item) => {
            return (
              <Grid item xs={12} sm={6} md={6} lg={4} key={item.id}>
                <Box
                  sx={{
                    backgroundColor: "#EAEAFF",
                    borderRadius: "12px",
                    p: 2,
                    boxShadow: "0px 4px 4px 0px #00000040",
                    // position: "relative",
                  }}
                >
                  <Grid container alignItems="center">
                    <Grid
                      container
                      //   mb={2}
                      spacing={{ md: 8, sm: 2, xs: 1 }}
                      alignItems="center"
                      justifyContent="center"
                    >
                      {/* Logo */}

                      <Grid item mb={2} xs={12} sm={3}>
                        <Box
                          component="img"
                          src={item?.productImage}
                          // alt="Job"
                          sx={{
                            width: { xs: "100%", sm: 80, md: 100, lg: 110 },
                            height: { xs: 180, sm: 90, md: 100, lg: 110 },
                            maxHeight: 200,
                            maxWidth: 200,
                            objectFit: "cover",
                            borderRadius: 2,
                          }}
                        />
                      </Grid>

                      {/* Job Details */}
                      <Grid item xs={12} sm={9}>
                        <Typography
                          sx={{
                            fontSize: { xs: "16px", sm: "18px", md: "24px" },
                            fontWeight: 600,
                          }}
                        >
                          {item?.productName}
                        </Typography>
                        {/* Company Name */}
                        <Typography
                          sx={{
                            fontSize: { xs: "10px", sm: "12px", md: "14px" },
                            fontWeight: 400,
                            // mt: 0.5,
                            color: "#494949",
                          }}
                        >
                          Product Id: {item?.productId}
                        </Typography>

                        {/*  Franchise Title */}
                        <Typography
                          sx={{
                            fontSize: { xs: "13px", sm: "13px", md: "15px" },
                            fontWeight: 600,
                            mt: 0.5,
                            color: "#000000",
                          }}
                        >
                          {item?.productDescription}
                        </Typography>
                        <Grid spacing={{ sm: 0.5, xs: 1, md: 1 }} container>
                          <Grid item xs={6} sm={6}>
                            {" "}
                            <Button
                              fullWidth
                              sx={{
                                fontWeight: 600,
                                color: "#01008B",
                                fontSize: {
                                  xs: "10px",
                                  sm: "10px",
                                  md: "13px",
                                  lg: "13px",
                                },
                                p: 0,
                                borderRadius: "6px",
                              }}
                              variant="outlined"
                              onClick={() => {
                                setOpen(true);
                                setModalData(item);
                                setViewType("company");
                              }}
                            >
                              Company Details
                            </Button>
                          </Grid>
                          <Grid item xs={6}>
                            <Button
                              fullWidth
                              variant="contained"
                              onClick={() => {
                                setOpen(true);
                                setModalData(item);
                                setViewType("product");
                              }}
                              sx={{
                                backgroundColor:
                                  item?.hasApplied !== true
                                    ? "#01008B"
                                    : "green",
                                // py: 1,
                                fontSize: {
                                  xs: "10px",
                                  sm: "10px",
                                  md: "13px",
                                  lg: "13px",
                                },
                                pointerEvents: item?.hasApplied
                                  ? "none"
                                  : "auto",
                                borderRadius: "6px",
                                textTransform: "none",
                                fontWeight: 500,
                                "&:hover": {
                                  backgroundColor: "#0201b3",
                                },
                                p: 0,
                              }}
                            >
                              Product Details
                            </Button>
                          </Grid>
                        </Grid>

                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "end",
                            p: { sm: 1, xs: 0 },
                          }}
                        >
                          <Typography
                            sx={{
                              fontSize: { xs: "10px", sm: "12px", md: "13px" },
                              color: "#494949",
                            }}
                          >
                           Posted On {formatDate(item?.createdDate)}
                          </Typography>
                        </Box>
                      </Grid>
                    </Grid>

                    <Grid item xs={12}>
                      <Button
                        fullWidth
                        variant="contained"
                        onClick={() => Applyinterested(item?.id)}
                        sx={{
                          backgroundColor:
                            item?.hasApplied !== true ? "#01008B" : "green",
                          // py: 1,
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          borderRadius: "6px",
                          textTransform: "none",
                          fontWeight: 500,
                          "&:hover": {
                            backgroundColor: "#0201b3",
                          },
                          p: 0,
                        }}
                      >
                        I am Interested
                      </Button>
                    </Grid>
                  </Grid>
                </Box>
              </Grid>
            );
          })}
        </Grid>
      </Box>
      <CompnayInforamtion
        modalData={modalData}
        applied={true}
        open={open}
        setOpen={setOpen}
        viewType={viewType}
        getRecept={() => {
          // getPaymentRec({ ...getPaymentObj });
        }}
      />
      <Box sx={{ pt: 10 }}>
        <Footer />
      </Box>
    </>
  );
}
